module.exports = __webpack_public_path__ + "static/media/gold-bar-on-gradient.0b461a67.png";